(function () {

  // ─── Age Gate ───
  var ageGate = document.getElementById("ll-ageGate");
  var ageYes = document.getElementById("ll-ageYes");
  var ageNo = document.getElementById("ll-ageNo");

  if (ageGate) {
    if (sessionStorage.getItem("ll-age-verified") === "true") {
      ageGate.classList.add("is-hidden");
    } else {
      document.body.style.overflow = "hidden";
    }

    if (ageYes) {
      ageYes.addEventListener("click", function () {
        ageGate.classList.add("is-hidden");
        document.body.style.overflow = "";
        sessionStorage.setItem("ll-age-verified", "true");
      });
    }

    if (ageNo) {
      ageNo.addEventListener("click", function () {
        window.location.href = "https://www.google.com";
      });
    }
  }

  // ─── Hero Carousel ───
  var hero = document.getElementById("ll-hero");
  var slidesWrap = document.getElementById("ll-hero-slides");
  var dotsWrap = document.getElementById("ll-hero-dots");

  var eyebrowEl = document.getElementById("ll-heroEyebrow");
  var titleEl = document.getElementById("ll-heroTitle");
  var subtitleEl = document.getElementById("ll-heroSubtitle");
  var ctaPrimary = document.getElementById("ll-heroCtaPrimary");
  var ctaSecondary = document.getElementById("ll-heroCtaSecondary");

  var prevBtn = document.getElementById("ll-prev");
  var nextBtn = document.getElementById("ll-next");

  if (hero && slidesWrap && dotsWrap) {
    var slideEls = Array.from(slidesWrap.querySelectorAll("[data-ll-slide]"));
    var dotEls = Array.from(dotsWrap.querySelectorAll(".ll-dot"));
    var heroData = (window.ll && window.ll.heroData) || [];
    var activeIndex = 0;
    var heroContent = hero.querySelector(".ll-hero__content");
    var heroTextTimer = null;

    function setHeroText(index, animate) {
      var s = heroData[index];
      if (!s) return;

      function applyText() {
        if (eyebrowEl) eyebrowEl.textContent = s.eyebrow || "";
        if (titleEl) titleEl.textContent = s.title || "";
        if (subtitleEl) subtitleEl.textContent = s.subtitle || "";

        if (s.ctaPrimary && ctaPrimary) {
          ctaPrimary.textContent = s.ctaPrimary.label || "Shop Now";
          ctaPrimary.href = s.ctaPrimary.href || "#";
        }
        if (s.ctaSecondary && ctaSecondary) {
          ctaSecondary.textContent = s.ctaSecondary.label || "Browse Specials";
          ctaSecondary.href = s.ctaSecondary.href || "#";
        }
      }

      if (!animate || !heroContent) {
        applyText();
        return;
      }

      heroContent.classList.add("is-switching");
      if (heroTextTimer) window.clearTimeout(heroTextTimer);
      heroTextTimer = window.setTimeout(function () {
        applyText();
        heroContent.classList.remove("is-switching");
      }, 180);
    }

    function setActive(nextIndex, options) {
      if (!slideEls.length) return;
      var opts = options || {};
      var index = ((nextIndex % slideEls.length) + slideEls.length) % slideEls.length;
      activeIndex = index;

      slideEls.forEach(function (el, idx) { el.classList.toggle("is-active", idx === index); });
      dotEls.forEach(function (el, idx) { el.classList.toggle("is-active", idx === index); });
      setHeroText(index, !opts.instant);
    }

    setHeroText(0, false);

    function heroNext() { setActive(activeIndex + 1); }
    function heroPrev() { setActive(activeIndex - 1); }

    if (prevBtn) prevBtn.addEventListener("click", heroPrev);
    if (nextBtn) nextBtn.addEventListener("click", heroNext);

    dotEls.forEach(function (dot, i) {
      dot.addEventListener("click", function () { setActive(i); });
    });

    // Auto-rotate
    var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var intervalMs = 6000;
    var timer = null;

    function startHero() {
      if (prefersReduced) return;
      stopHero();
      timer = window.setInterval(heroNext, intervalMs);
    }
    function stopHero() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    hero.addEventListener("mouseenter", stopHero);
    hero.addEventListener("mouseleave", startHero);
    startHero();
  }

  // ─── Cart (AJAX) ───
  var cartBadge = document.querySelector("[data-cart-count]");
  var toast = document.getElementById("ll-toast");
  var toastClose = document.getElementById("ll-toastClose");
  var toastImg = document.getElementById("ll-toastImg");
  var toastTitle = document.getElementById("ll-toastTitle");
  var toastMeta = document.getElementById("ll-toastMeta");
  var toastPrice = document.getElementById("ll-toastPrice");
  var toastTotals = document.getElementById("ll-toastTotals");
  var toastTimer = null;

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function hideToast() {
    if (!toast) return;
    toast.classList.remove("is-active");
    toast.setAttribute("aria-hidden", "true");
    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }
  }

  function showToast(item, cart) {
    if (!toast) return;
    if (toastImg) {
      toastImg.src = item.image ? item.image.replace(/(\.[^.\/]+)(\?.*)?$/, "_120x$1$2") : "";
      toastImg.alt = item.product_title || item.title || "";
    }
    if (toastTitle) toastTitle.textContent = item.product_title || item.title || "";
    if (toastMeta) {
      var meta = [];
      if (item.variant_title && item.variant_title !== "Default Title") meta.push(item.variant_title);
      if (item.quantity) meta.push("Qty " + item.quantity);
      toastMeta.textContent = meta.join(" · ");
    }
    if (toastPrice) toastPrice.textContent = formatMoney(item.final_line_price || item.line_price || item.price * (item.quantity || 1));
    if (toastTotals && cart) {
      toastTotals.innerHTML =
        '<span>Cart subtotal (' + cart.item_count + ' item' + (cart.item_count !== 1 ? "s" : "") + ')</span>' +
        '<strong>' + formatMoney(cart.items_subtotal_price || cart.total_price) + '</strong>';
    }

    toast.classList.add("is-active");
    toast.setAttribute("aria-hidden", "false");

    // restart progress animation
    var bar = toast.querySelector(".ll-toast__progress span");
    if (bar) { bar.style.animation = "none"; void bar.offsetWidth; bar.style.animation = ""; }

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5000);
  }

  if (toastClose) toastClose.addEventListener("click", hideToast);
  if (toast) {
    toast.addEventListener("mouseenter", function () { if (toastTimer) clearTimeout(toastTimer); });
    toast.addEventListener("mouseleave", function () { toastTimer = setTimeout(hideToast, 2500); });
  }

  function updateCartCount(cart) {
    if (cartBadge && cart) {
      cartBadge.textContent = cart.item_count;
      cartBadge.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.4)' },
        { transform: 'scale(1)' }
      ], { duration: 280, easing: "cubic-bezier(.34,1.56,.64,1)" });
    }
  }

  function fetchCart() {
    return fetch(window.ll.routes.cart_url + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form.action && form.action.indexOf("/cart/add") !== -1) {
      e.preventDefault();
      var formData = new FormData(form);
      var btn = form.querySelector("button[type='submit']");
      var originalText = btn ? btn.textContent : "";

      if (btn) {
        btn.disabled = true;
        btn.textContent = "Adding…";
      }

      fetch(window.ll.routes.cart_add_url + ".js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (item) {
          return fetchCart().then(function (cart) {
            updateCartCount(cart);
            showToast(item, cart);
            if (btn) {
              btn.textContent = "✓ Added";
              btn.style.background = "#16a34a";
              btn.style.color = "#fff";
              setTimeout(function () {
                btn.textContent = originalText;
                btn.style.background = "";
                btn.style.color = "";
                btn.disabled = false;
              }, 1100);
            }
          });
        })
        .catch(function (err) {
          console.error("Add to cart error:", err);
          if (btn) {
            btn.textContent = (err && err.description) || "Couldn't add — try again";
            btn.style.background = "#dc2626";
            btn.style.color = "#fff";
            setTimeout(function () {
              btn.textContent = originalText;
              btn.style.background = "";
              btn.style.color = "";
              btn.disabled = false;
            }, 1800);
          }
        });
    }
  });

  // ─── Cart: terms & conditions gate ───
  var termsGate = document.querySelector("[data-terms-gate]");
  var checkoutBtn = document.querySelector("[data-checkout-btn]");
  if (termsGate && checkoutBtn) {
    var syncGate = function () {
      var ok = termsGate.checked;
      checkoutBtn.disabled = !ok;
      checkoutBtn.setAttribute("aria-disabled", String(!ok));
      checkoutBtn.classList.toggle("is-locked", !ok);
    };
    termsGate.addEventListener("change", syncGate);
    syncGate();

    var cartForm = checkoutBtn.closest("form");
    if (cartForm) {
      cartForm.addEventListener("submit", function (e) {
        var btn = e.submitter || document.activeElement;
        if (btn && btn.name === "checkout" && !termsGate.checked) {
          e.preventDefault();
          termsGate.focus();
          var wrap = termsGate.closest(".ll-cart__terms");
          if (wrap) {
            wrap.classList.add("is-shake");
            setTimeout(function () { wrap.classList.remove("is-shake"); }, 500);
          }
        }
      });
    }
  }

  // ─── Search Overlay ───
  var searchToggle = document.querySelector("[data-search-toggle]");
  var searchOverlay = document.getElementById("ll-searchOverlay");
  var searchClose = document.getElementById("ll-searchClose");
  var searchInput = document.getElementById("ll-searchInput");

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener("click", function () {
      searchOverlay.classList.add("is-active");
      searchOverlay.setAttribute("aria-hidden", "false");
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 150);
    });

    if (searchClose) {
      searchClose.addEventListener("click", function () {
        searchOverlay.classList.remove("is-active");
        searchOverlay.setAttribute("aria-hidden", "true");
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && searchOverlay.classList.contains("is-active")) {
        searchOverlay.classList.remove("is-active");
        searchOverlay.setAttribute("aria-hidden", "true");
      }
    });

    searchOverlay.addEventListener("click", function (e) {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove("is-active");
        searchOverlay.setAttribute("aria-hidden", "true");
      }
    });
  }

  // ─── Quick View Modal ───
  var modal = document.getElementById("ll-quickView");
  var modalClose = document.getElementById("ll-modalClose");
  var modalOverlay = modal ? modal.querySelector(".ll-modal__overlay") : null;
  var modalAddBtn = modal ? modal.querySelector("[data-modal-add-cart]") : null;
  var activeQuickViewVariantId = null;

  function openModal(productData) {
    if (!modal) return;

    var titleEl = document.getElementById("ll-modalTitle");
    var priceEl = document.getElementById("ll-modalPrice");
    var metaEl = document.getElementById("ll-modalMeta");
    var imgEl = document.getElementById("ll-modalImg");

    if (titleEl) titleEl.textContent = productData.name;
    if (priceEl) priceEl.textContent = productData.price;
    if (metaEl) metaEl.textContent = productData.meta;
    if (imgEl) imgEl.style.backgroundImage = productData.img;
    activeQuickViewVariantId = productData.variantId || null;

    if (modalAddBtn) {
      modalAddBtn.disabled = !activeQuickViewVariantId;
      modalAddBtn.textContent = activeQuickViewVariantId ? "Add to Cart" : "Unavailable";
    }

    modal.classList.add("is-active");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove("is-active");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    activeQuickViewVariantId = null;
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-view]");
    if (!btn) return;

    var card = btn.closest(".ll-product");
    if (!card) return;

    var name = (card.querySelector(".ll-product__name a") || card.querySelector(".ll-product__name") || {}).textContent || "";
    var price = (card.querySelector(".ll-product__price") || {}).textContent || "";
    var meta = (card.querySelector(".ll-product__meta") || {}).textContent || "";
    var imgDiv = card.querySelector(".ll-product__img");
    var img = imgDiv ? imgDiv.style.backgroundImage : "";
    var handle = btn.getAttribute("data-product-handle");
    var fallbackVariantInput = card.querySelector("input[name='id']");
    var fallbackVariantId = fallbackVariantInput ? fallbackVariantInput.value : null;

    openModal({ name: name.trim(), price: price.trim(), meta: meta.trim(), img: img, variantId: fallbackVariantId });

    if (handle) {
      fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !modal || !modal.classList.contains("is-active")) return;
          var variant = (product.variants || []).find(function (v) { return v.available; });
          activeQuickViewVariantId = variant ? variant.id : null;
          if (modalAddBtn) {
            modalAddBtn.disabled = !activeQuickViewVariantId;
            modalAddBtn.textContent = activeQuickViewVariantId ? "Add to Cart" : "Sold Out";
          }
        })
        .catch(function () {});
    }
  });

  if (modalClose) modalClose.addEventListener("click", closeModal);
  if (modalOverlay) modalOverlay.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal && modal.classList.contains("is-active")) {
      closeModal();
    }
  });

  // Modal QTY controls
  document.addEventListener("click", function (e) {
    if (e.target.matches("[data-qty-minus]")) {
      var input = e.target.parentElement.querySelector("[data-qty-input], .ll-qtyInput");
      if (input) {
        var val = parseInt(input.value);
        if (val > 1) input.value = val - 1;
      }
    }
    if (e.target.matches("[data-qty-plus]")) {
      var input = e.target.parentElement.querySelector("[data-qty-input], .ll-qtyInput");
      if (input) {
        var val = parseInt(input.value);
        input.value = val + 1;
      }
    }
  });

  if (modalAddBtn) {
    modalAddBtn.addEventListener("click", function () {
      if (!activeQuickViewVariantId) return;
      var qtyInput = modal.querySelector("[data-qty-input]");
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      var originalText = modalAddBtn.textContent;
      modalAddBtn.disabled = true;
      modalAddBtn.textContent = "Adding...";

      fetch(window.ll.routes.cart_add_url + ".js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: Number(activeQuickViewVariantId),
          quantity: qty
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (item) {
          return fetchCart().then(function (cart) {
            updateCartCount(cart);
            showToast(item, cart);
            modalAddBtn.textContent = "Added";
            setTimeout(function () {
              modalAddBtn.textContent = originalText;
              modalAddBtn.disabled = false;
            }, 800);
          });
        })
        .catch(function (err) {
          console.error("Quick view add to cart error:", err);
          modalAddBtn.textContent = "Try again";
          setTimeout(function () {
            modalAddBtn.textContent = originalText;
            modalAddBtn.disabled = false;
          }, 1000);
        });
    });
  }

  // ─── Mobile Menu ───
  var hamburger = document.getElementById("ll-hamburger");
  var mobileMenu = document.getElementById("ll-mobileMenu");
  var mobileClose = document.getElementById("ll-mobileClose");

  if (hamburger && mobileMenu) {
    hamburger.addEventListener("click", function () {
      mobileMenu.classList.add("is-active");
      mobileMenu.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    });

    if (mobileClose) {
      mobileClose.addEventListener("click", function () {
        mobileMenu.classList.remove("is-active");
        mobileMenu.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      });
    }

    // Accordion toggles
    document.querySelectorAll(".ll-mobileMenu__toggle").forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var sub = toggle.nextElementSibling;
        if (sub) {
          toggle.classList.toggle("is-open");
          sub.classList.toggle("is-open");
        }
      });
    });

    // Close on link click
    mobileMenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        mobileMenu.classList.remove("is-active");
        mobileMenu.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      });
    });
  }

  // ─── Offer Banner Carousel ───
  var offerCarousel = document.getElementById("ll-offerCarousel");
  var offerDotsWrap = document.getElementById("ll-offerDots");
  var offerPrev = document.getElementById("ll-offerPrev");
  var offerNext = document.getElementById("ll-offerNext");

  if (offerCarousel && offerDotsWrap) {
    var offerSlides = Array.from(offerCarousel.querySelectorAll(".ll-offerBanner__slide"));
    var offerIndex = 0;

    // Create dots
    offerSlides.forEach(function (_, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "ll-offerBanner__dot" + (i === 0 ? " is-active" : "");
      dot.setAttribute("aria-label", "Offer " + (i + 1));
      dot.addEventListener("click", function () { setOfferSlide(i); });
      offerDotsWrap.appendChild(dot);
    });

    var offerDots = Array.from(offerDotsWrap.querySelectorAll(".ll-offerBanner__dot"));

    function setOfferSlide(idx) {
      offerIndex = ((idx % offerSlides.length) + offerSlides.length) % offerSlides.length;
      offerSlides.forEach(function (s, i) { s.classList.toggle("is-active", i === offerIndex); });
      offerDots.forEach(function (d, i) { d.classList.toggle("is-active", i === offerIndex); });
    }

    if (offerPrev) offerPrev.addEventListener("click", function () { setOfferSlide(offerIndex - 1); });
    if (offerNext) offerNext.addEventListener("click", function () { setOfferSlide(offerIndex + 1); });

    // Auto-rotate every 4s
    var offerTimer = setInterval(function () { setOfferSlide(offerIndex + 1); }, 4000);
    offerCarousel.addEventListener("mouseenter", function () { clearInterval(offerTimer); });
    offerCarousel.addEventListener("mouseleave", function () {
      offerTimer = setInterval(function () { setOfferSlide(offerIndex + 1); }, 4000);
    });
  }

  // ─── Scroll header shadow + progress bar ───
  var header = document.querySelector(".ll-header");
  var progressBar = document.getElementById("ll-progressBar");
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function onScroll() {
    var y = window.scrollY;
    if (header) {
      header.style.boxShadow = y > 50 ? "0 2px 20px rgba(0,0,0,0.06)" : "none";
    }
    if (progressBar && !prefersReducedMotion) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      progressBar.style.width = h > 0 ? ((y / h) * 100) + "%" : "0%";
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // ─── Scroll reveal animations ───
  if ("IntersectionObserver" in window && !prefersReducedMotion) {
    // Auto-tag common containers so existing sections animate without markup changes
    var autoStagger = [
      ".ll-grid--products",
      ".ll-about-cats",
      ".ll-about-commits",
      ".ll-about-partners",
      ".ll-about-stats",
      ".ll-tmls",
      ".ll-bcards",
      ".ll-stats",
      ".ll-ig",
      ".ll-gallery",
      ".ll-trustBar__grid",
      ".ll-footer__inner",
      ".ll-about-cta__btns"
    ];
    autoStagger.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.hasAttribute("data-stagger")) el.setAttribute("data-stagger", "");
      });
    });

    var autoFadeUp = [
      ".ll-section__head",
      ".ll-edsplit",
      ".ll-dotw",
      ".ll-videoBanner__content",
      ".ll-ctab",
      ".ll-timeline__item",
      ".ll-rtxt",
      ".ll-faqBlock",
      ".ll-contact__grid",
      ".ll-marquee__head",
      ".ll-license",
      ".ll-license__card",
      ".ll-license__notice",
      ".ll-404__actions"
    ];
    autoFadeUp.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.hasAttribute("data-anim")) el.setAttribute("data-anim", "fade-up");
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -60px 0px" });

    document.querySelectorAll("[data-anim], [data-stagger]").forEach(function (el) {
      io.observe(el);
    });
  } else if (prefersReducedMotion) {
    document.querySelectorAll("[data-anim], [data-stagger]").forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  // ─── Parallax for elements with data-parallax ───
  if (!prefersReducedMotion) {
    var parallaxEls = document.querySelectorAll("[data-parallax]");
    if (parallaxEls.length) {
      var rafId = null;
      function updateParallax() {
        parallaxEls.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          var vh = window.innerHeight;
          if (rect.bottom > 0 && rect.top < vh) {
            var speed = parseFloat(el.dataset.parallax) || 0.2;
            var offset = (rect.top - vh / 2) * -speed;
            el.style.transform = "translate3d(0," + offset.toFixed(2) + "px,0)";
          }
        });
        rafId = null;
      }
      window.addEventListener("scroll", function () {
        if (!rafId) rafId = window.requestAnimationFrame(updateParallax);
      }, { passive: true });
      updateParallax();
    }
  }

  // ─── Blur-up image loader (opt-in via .ll-img-blur class) ───
  document.querySelectorAll("img.ll-img-blur").forEach(function (img) {
    if (img.complete) img.classList.add("is-loaded");
    else img.addEventListener("load", function () { img.classList.add("is-loaded"); });
  });

})();
